import { useTranslation } from "react-i18next";
import singleMode from "./filterBaseSingle";

import collatorSort from "utils/collatorSort";

const rawItems = [
	{ key: "af" },
	{ key: "ar" },
	{ key: "az" },
	{ key: "be" },
	{ key: "bg" },
	{ key: "bn" },
	{ key: "bs" },
	{ key: "ca" },
	{ key: "cs" },
	{ key: "da" },
	{ key: "de" },
	{ key: "el" },
	{ key: "en" },
	{ key: "es" },
	{ key: "et" },
	{ key: "fa" },
	{ key: "fi" },
	{ key: "fl" },
	{ key: "fr" },
	{ key: "he" },
	{ key: "hi" },
	{ key: "hr" },
	{ key: "hu" },
	{ key: "hy" },
	{ key: "id" },
	{ key: "is" },
	{ key: "it" },
	{ key: "ja" },
	{ key: "ka" },
	{ key: "kk" },
	{ key: "ko" },
	{ key: "ls" },
	{ key: "lt" },
	{ key: "lv" },
	{ key: "mk" },
	{ key: "mn" },
	{ key: "ms" },
	{ key: "my" },
	{ key: "nl" },
	{ key: "no" },
	{ key: "pa" },
	{ key: "pl" },
	{ key: "pt" },
	{ key: "ro" },
	{ key: "ru" },
	{ key: "sk" },
	{ key: "sq" },
	{ key: "sr" },
	{ key: "sv" },
	{ key: "ta" },
	{ key: "te" },
	{ key: "th" },
	{ key: "tr" },
	{ key: "uk" },
	{ key: "ur" },
	{ key: "uz" },
	{ key: "vi" },
	{ key: "zht" },
	{ key: "zhu" },
];

export { rawItems };

export const isValid = (value) => {
	if (value === "") {
		return true;
	}
	const validValuesArray = rawItems.map((item) => item.key);
	return validValuesArray.includes(value);
};

export const compute = {
	valueToApiParam: (value) => {
		const current = rawItems.find((item) => item.key === value);
		return current ? current.key : null;
	},
	valueToUrl: (value) => {
		const current = rawItems.find((item) => item.key === value);
		return current ? current.key : "";
	},
	urlToApiParam: (value) => {
		if (!value) return null;
		const current = rawItems.find((item) => item.key === value);
		return current?.key || null;
	},
};

const useFilterLanguage = ({ initial }) => {
	const { t } = useTranslation(["languages"]);
	const items = rawItems.map((item) => ({
		key: item.code,
		...item,
		content: t(item.key),
		text: t(item.key),
		value: item.key,
		selected: initial !== item.key,
		meta: {
			url: item.key,
		},
	}));

	const sortedItems = collatorSort(
		collatorSort(items, "content"),
		"selected"
	);

	return {
		rawItems,
		items: sortedItems,
		compute,
		isValid,
		...singleMode({ items, initial, compute }),
	};
};

export default useFilterLanguage;
